export class CreateDeliverySchedule{
    public poItemNo?:string
    public item_no?:string
    public quantity?:number
    public delivery_date?:string
    public status?:string
    public vendor?:string
    public poAgreementNo?:string
}